export const parameters = {
  options: {
    storySort: {
      order: [
        'football Widgets',
        'basketball Widgets',
        'tennis Widgets',
        'multisport Widgets',
        'ice-hockey Widgets',
        'organisms',
        'molecules',
      ],
    },
  },
  layout: 'fullscreen',
};
